import styled from "styled-components";
import * as palette from "../../SCVariables";
import { MdKeyboardArrowRight, MdArrowForward } from "react-icons/md";

export const PriceContainer = styled.div`
  color: ${palette.mainWhite};
  background: ${palette.mainBlue};

  @media screen and (max-width: 768px) {
    padding: 100px 0;
  }
`;

export const PriceWrapper = styled.div`
  display: grid;
  z-index: 1;
  height: 860px;
  width: 100%;
  max-width: 1100px;
  margin: auto auto;
  padding: 0 24px;
  justify-content: center;
`;
export const PriceRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col1 col2'` : `'col2 col1'`};

  @media screen and (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
  }
`;
export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;
export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;
`;
export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;

  @media screen and (max-width: 480px) {
    font-size: 30px;
  }
`;
export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 24px;

  @media screen and (max-width: 700px) {
    text-align: left;
  }
`;

export const CTASection = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const CTAButton = styled.button`
  padding: 15px;
  border: none;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  width: 200px;
  background: ${palette.mainOrange};
  color: ${palette.mainBlack};
  transition: all 0.2s ease-in-out;
  align-items: center;
  display: flex;
  justify-content: center;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${palette.mainBlack};
    color: ${palette.mainOrange};
  }
`;
export const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;
export const Img = styled.img`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
`;
export const ArrowForward = styled(MdArrowForward)`
  margin-left: 8px;
  font-size: 20px;
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
  margin-left: 8px;
  font-size: 20px;
`;